import { Button, Typography } from '@breetometer/components';
import { ChevronDown, NotificationIcon } from 'BreetAssets';
import { memo, type RefObject, useCallback, useMemo } from 'react';

import type { IMobileMenuItemSub } from './SidebarMobile.helpers';
import { SubMenus } from './SubMenus';

const MenuItemSub = ({ sideMenuItem, setMobileMenu, onMenuClick, dropDownArgs }: IMobileMenuItemSub) => {
	const { buttonRef, handleVisibility: handleSubMenuVisibility, visible, dropdownRef, controlRef, dropdownStyles } = dropDownArgs;

	const hasSubMenu = sideMenuItem.subMenu?.length;
	const isNotifications = sideMenuItem.icon && sideMenuItem.menu === 'Notifications';
	const chevronClass = useMemo(() => `menumobileicon toggleicon${visible ? ' open' : ''} svg-light`, [visible]);

	const handleMenuClick = useCallback(() => {
		if (hasSubMenu) {
			handleSubMenuVisibility();
		} else {
			setMobileMenu(onMenuClick(sideMenuItem.url))().catch(console.error);
		}
	}, [hasSubMenu, sideMenuItem.url, handleSubMenuVisibility, setMobileMenu, onMenuClick]);

	return (
		<Typography
			as='li'
			className='sidemenumobile_menuitem'
			key={sideMenuItem.menu}
			ref={hasSubMenu ? (controlRef as RefObject<HTMLParagraphElement>) : null}
		>
			<Button
				variant='native'
				onClick={handleMenuClick}
				ref={hasSubMenu ? buttonRef : null}
				className='color-neutral-50'
			>
				{sideMenuItem.menu}
				{hasSubMenu && (
					<ChevronDown
						className={chevronClass}
						mobileMenu
					/>
				)}
				{isNotifications && (
					<NotificationIcon
						className='menumobileicon svg-notification cursor_pointer'
						variant='new-message'
					/>
				)}
			</Button>

			{visible && hasSubMenu && (
				<SubMenus
					dropdownRef={dropdownRef}
					dropdownStyles={dropdownStyles}
					setMobileMenu={setMobileMenu}
					onMenuClick={onMenuClick}
					subMenus={sideMenuItem.subMenu}
				/>
			)}
		</Typography>
	);
};

export default memo(MenuItemSub);
